import React from "react";
import PublicNavbar from "../components/PublicNavbar";

export default function CourtRules() {
  return (
    <div className="w-full bg-white font-sans pb-10">
      <PublicNavbar />

      {/* Header Badge */}
      <div className="flex justify-center mt-10 mb-12 px-4">
        <div className="relative inline-block">
          {/* Lime Green Shadow Layer */}
          <div className="absolute inset-0 bg-[#c5e153] translate-x-[-4px] translate-y-[6px] rounded-2xl md:rounded-[2rem]" />
          {/* Main Blue Badge */}
          <div className="relative flex items-center gap-3 bg-[#074b85] text-white px-8 py-3 md:px-12 md:py-4 rounded-2xl md:rounded-[2rem] shadow-sm">
            <div className="flex-shrink-0">
              <img src="/newassets/icon 6.png" alt="Rules" className="w-6 h-6 md:w-8 md:h-8 object-contain" />
            </div>
            <span className="font-extrabold text-xl md:text-3xl tracking-tight uppercase">
              Court Rules
            </span>
          </div>
        </div>
      </div>

      {/* Main Content Container */}
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20">
          
          {/* LEFT COLUMN: Pickleball Rules and Regulation */}
          <div className="space-y-8">
            <div className="text-center lg:text-left">
              <h2 className="text-[#ff7f00] text-3xl md:text-4xl font-black uppercase leading-tight text-center">
                Pickleball Rules and Regulation
              </h2>
              <p className="text-[#004a80] text-sm md:text-base font-black mt-2 tracking-widest uppercase text-center">
                Play Fair. Play Safe. Respect the Game
              </p>
            </div>

            <ul className="space-y-2 lg:space-y-4">
              {[
                "Proper Court Etiquette must be observed at all times.",
                "First come, First serve basis unless scheduled.",
                "Wear proper sports attire and non-marking shoes.",
                "Respect fellow players, Coaches, and Staff.",
                "Outside Food and Drinks Not Allowed. (Personal Tumbler and Water is allowed)",
                "Help keep the court clean and damage-free.",
                "Follow staff instructions for everyone's safety.",
              ].map((rule, index) => (
                <li key={index} className="flex items-start gap-4">
                  <img src="/newassets/blue.png" alt="bullet" className="w-6 h-6 md:w-7 md:h-7 shrink-0" />
                  <p className="text-[#004a80] text-base md:text-lg font-semibold leading-snug">{rule}</p>
                </li>
              ))}
            </ul>
          </div>

          {/* RIGHT COLUMN: Court Rules & House Rules */}
          <div className="space-y-16">
            
            {/* Upper Section: Court Rules and Etiquette */}
            <div className="space-y-8">
              <div className="text-center lg:text-left">
                <h2 className="text-[#ff7f00] text-3xl md:text-4xl font-black uppercase leading-tight text-center">
                  Court Rules and Etiquette
                </h2>
                <p className="text-[#004a80] text-sm md:text-base font-black mt-2 tracking-widest uppercase text-center">
                  Where Fun Meets Respect
                </p>
              </div>
              <ul className="space-y-2 lg:space-y-4">
                {[
                  "Play responsibly, share the court, and showsportsmanship.",
                  "Your cooperation keeps the game enjoyable for everyone.",
                ].map((rule, index) => (
                  <li key={index} className="flex items-start gap-4">
                    <img src="/newassets/green.png" alt="bullet" className="w-6 h-6 md:w-7 md:h-7 shrink-0" />
                    <p className="text-[#004a80] text-base md:text-lg font-semibold leading-snug">{rule}</p>
                  </li>
                ))}
              </ul>
            </div>

            {/* Lower Section: House Rules */}
            <div className="space-y-8">
              <div className="text-center lg:text-left">
                <h2 className="text-[#ff7f00] text-3xl md:text-4xl font-black uppercase leading-tight text-center">
                  House Rules
                </h2>
                <p className="text-[#004a80] text-sm md:text-base font-black mt-2 tracking-widest uppercase text-center">
                  Where Fun Play Smart. Play Kind. Play Pickleball With Respect
                </p>
              </div>
              <ul className="space-y-2 lg:space-y-4">
                {[
                  "By entering the court, you agree to follow all rules and respect other players.",
                  "Let's keep the game fun and safe for all!",
                ].map((rule, index) => (
                  <li key={index} className="flex items-start gap-4">
                    <img src="/newassets/yellow.png" alt="bullet" className="w-6 h-6 md:w-7 md:h-7 shrink-0" />
                    <p className="text-[#004a80] text-base md:text-lg font-semibold leading-snug">{rule}</p>
                  </li>
                ))}
              </ul>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
}